import * as React from 'react';
import * as ReactDOM from 'react-dom';
import createRoutes from './routes/AppRouter';
import { Index } from './app';
import { history, store } from './utils';

const routes = createRoutes();

ReactDOM.render(<Index routes={routes} store={store} history={history} />, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.tsx